// Gruntfile.js uses string-replace-loader to replace these values during build time.
export const VERSION = '5.0.0';
export const ID = '0ca6f889545c33cce851b420c24945f6eb685aeb';
export const DATE = '2025-03-05T17:05:43.991Z';
